import Icon, {
  FileDoneOutlined,
  SnippetsOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

import { PanelViews } from 'types/PanelViews';

import DrawerToolbarButton from './DrawerToolbarButton';
import EditButton from './EditButton';
import { BundleIcon, TemplateIcon } from './icons';
import NavigationMenu from './NavigationMenu';
import ReloadButton from './ReloadButton';
import ScaleInput from './ScaleInput';

const Container = styled.div`
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #f2ebeb;
  border-top: 1px solid #f2ebeb;
  display: flex;
  gap: 7px;
  padding: 0 7px;
  width: 100%;
`;

export interface AdViewToolbarProps {
  disabled?: boolean;
}

function AdViewToolbar({ disabled }: AdViewToolbarProps) {
  return (
    <Container>
      <NavigationMenu />
      <ReloadButton />
      <ScaleInput />

      <EditButton />

      <DrawerToolbarButton
        disabled={disabled}
        panelType={PanelViews.ASSETS}
        label="Assets"
        icon={<SnippetsOutlined />}
      />

      <DrawerToolbarButton
        disabled={disabled}
        panelType={PanelViews.TEMPLATES}
        label="Templates"
        icon={<Icon component={TemplateIcon} />}
      />

      <DrawerToolbarButton
        disabled={disabled}
        panelType={PanelViews.TEARSHEETS}
        label="Tearsheets"
        icon={<FileDoneOutlined />}
      />

      <DrawerToolbarButton
        disabled={disabled}
        panelType={PanelViews.BUNDLES}
        label="Bundles"
        icon={<Icon component={BundleIcon} />}
      />

      <DrawerToolbarButton
        disabled={disabled}
        panelType={PanelViews.VIDEO_BUNDLES}
        label="Video Bundles"
        icon={<VideoCameraOutlined />}
      />
    </Container>
  );
}

export default AdViewToolbar;
